const VISITOR_ID_KEY = "practice_visibility_visitor_id";

/**
 * A random, non-identifying browser marker used solely for the public scan
 * quota. It is not a lead field, analytics identifier or report credential.
 */
export function getPracticeVisibilityVisitorId() {
  if (typeof window === "undefined") return null;
  try {
    const existing = window.localStorage.getItem(VISITOR_ID_KEY);
    if (existing && /^[A-Za-z0-9_-]{20,80}$/.test(existing)) return existing;
    const created = window.crypto?.randomUUID?.().replace(/-/g, "") ?? `${Date.now()}${Math.random()}`.replace(/\D/g, "");
    const normalized = created.slice(0, 64);
    window.localStorage.setItem(VISITOR_ID_KEY, normalized);
    return normalized;
  } catch {
    return null;
  }
}
